import exp from "constants";
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";

const useFilterManager = <T extends Record<string, any>>(initialFilters: T) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<T>(initialFilters);

  const updateFilter = useCallback(
    (key: keyof T, value: any) => {
      const newSearchParams = new URLSearchParams(searchParams);

      if (value !== null && value !== undefined && value !== "") {
        newSearchParams.set(key as string, String(value));
      } else {
        newSearchParams.delete(key as string);
      }

      setSearchParams(newSearchParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  const setMultipleFilters = useCallback(
    (updates: Partial<T>) => {
      const newSearchParams = new URLSearchParams(searchParams);

      Object.entries(updates).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          newSearchParams.set(key, String(value));
        } else {
          newSearchParams.delete(key);
        }
      });

      setSearchParams(newSearchParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  return {
    filters,
    setFilters,
    updateFilter,
    setMultipleFilters,
    searchParams,
  };
};

export default useFilterManager;
